var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#464655"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    style: {
      fill: "#FF4B55"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.33,
    style: {
      fill: "#73AF00"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "279.038,273.307 232.962,273.307 235.522,268.187 276.478,268.187  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "279.038,232.351 232.962,232.351 235.522,237.471 276.478,237.471  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "268.799,234.911 243.201,234.911 248.321,229.791 263.679,229.791  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.52,
    y: 260.51,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.52,
    y: 252.83,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.52,
    y: 240.03,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.52,
    y: 247.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 2.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 260.51,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 252.83,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 240.03,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 5.119
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 247.71,
    style: {
      fill: "#F5F5F5"
    },
    width: 7.679,
    height: 2.56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.08,
    y: 219.55,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.119,
    height: 10.239
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M243.201,216.993h-5.119v-2.8c0-1.281,1.039-2.32,2.32-2.32h0.48c1.281,0,2.32,1.039,2.32,2.32v2.8   H243.201z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 219.55,
    style: {
      fill: "#F5F5F5"
    },
    width: 5.119,
    height: 10.239
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M273.918,216.993h-5.119v-2.8c0-1.281,1.039-2.32,2.32-2.32h0.48c1.281,0,2.32,1.039,2.32,2.32v2.8   H273.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M256.96,240.03h-1.92c-5.125,0-9.279,4.154-9.279,9.279v16.318h20.478v-16.318   C266.239,244.185,262.085,240.03,256.96,240.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M239.053,256.156l-13.937-16.26c0.091-0.262,0.167-0.533,0.167-0.826c0-1.414-1.146-2.56-2.56-2.56   s-2.56,1.146-2.56,2.56s1.146,2.56,2.56,2.56c0.154,0,0.288-0.062,0.434-0.087l1.442,1.682l-6.996,16.323l7.679,7.679l6.63-15.47   l5.197,6.064L239.053,256.156z M226.601,261.504l-6.127-6.128l2.765-6.451l6.127,6.128L226.601,261.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M274.954,257.821l5.197-6.064l6.63,15.47l7.679-7.679l-6.996-16.323l1.442-1.682   c0.147,0.026,0.28,0.087,0.434,0.087c1.414,0,2.56-1.146,2.56-2.56s-1.146-2.56-2.56-2.56s-2.56,1.146-2.56,2.56   c0,0.293,0.076,0.564,0.167,0.826l-13.937,16.26L274.954,257.821z M282.699,255.053l6.127-6.128l2.765,6.451l-6.127,6.128   L282.699,255.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M258.898,214.879c-0.805-0.237-1.521-0.676-1.976-1.381c-0.304-0.471-0.612-1.006-0.921-1.625   c-0.309,0.619-0.617,1.154-0.921,1.625c-0.455,0.705-1.171,1.144-1.976,1.381c-4.241,1.249-7.342,5.147-7.342,9.793   c0,0.889,0.149,1.737,0.362,2.56h19.754c0.213-0.823,0.362-1.67,0.362-2.56C266.239,220.026,263.138,216.128,258.898,214.879z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M197.34,252.528c-0.13-1.591-0.214-3.195-0.214-4.819c0-3.288,0.298-6.522,0.826-9.695   c0.738,0.511,1.511,1.073,2.314,1.704c-0.375,2.625-0.581,5.291-0.581,7.992c0,1.893,0.097,3.763,0.28,5.608l5.411,1.626   c-0.338-2.37-0.572-4.772-0.572-7.234c0-1.223,0.073-2.434,0.17-3.638c2.826,3.134,5.056,6.92,5.056,11.104   c0,0.107,8.212-12.159-6.719-25.704l-0.107,5.759l-8.6-0.091c-0.775-0.008-1.456,0.542-1.592,1.305   c-0.654,3.679-1.006,7.441-1.006,11.264c0,1.087,0.028,2.167,0.082,3.241L197.34,252.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M220.052,201.099c1.119-0.862,1.325-2.47,0.461-3.59c-0.866-1.12-2.472-1.322-3.591-0.46   c-11.585,8.947-19.535,21.239-22.978,35.008l5.276,0.068C202.541,219.939,209.726,209.075,220.052,201.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M216.623,207.484c-5.567,5.452-9.781,11.869-12.648,18.839c1.583,1.3,2.88,2.615,3.957,3.922   c2.58-7.107,6.689-13.632,12.274-19.101c1.01-0.99,1.027-2.61,0.038-3.62C219.251,206.511,217.633,206.494,216.623,207.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M207.727,281.27c-3.796-5.447-6.697-11.556-8.497-18.117l2.975,1.093   c1.859,5.987,4.679,11.555,8.293,16.516l5.649-1.034c-3.19-3.965-5.812-8.404-7.728-13.199l3.34,1.227   c1.905,4.186,4.347,8.033,7.255,11.447l5.88-1.077c-2.312-2.361-4.334-5.017-6.076-7.883l-3.406-6.811   c-1.052-2.104-2.926-3.68-5.179-4.356l-8.059-2.422l-1.863-0.56l-2.683-0.806l-5.335-1.603l-2.848-0.856l1.763,5.288   c0.387,1.161,1.169,2.129,2.188,2.766c1.629,7.735,4.65,14.962,8.8,21.4L207.727,281.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M308.795,235.231l-0.107-5.759c-14.932,13.545-6.719,25.811-6.719,25.704   c0-4.184,2.23-7.97,5.056-11.104c0.098,1.205,0.17,2.415,0.17,3.638c0,2.462-0.234,4.864-0.572,7.234l5.411-1.626   c0.183-1.845,0.28-3.715,0.28-5.608c0-2.701-0.207-5.367-0.581-7.992c0.803-0.631,1.576-1.192,2.314-1.704   c0.529,3.173,0.826,6.407,0.826,9.695c0,1.624-0.084,3.228-0.214,4.819l5.251-1.578c0.054-1.074,0.082-2.154,0.082-3.241   c0-3.823-0.353-7.585-1.006-11.264c-0.136-0.763-0.817-1.313-1.592-1.305L308.795,235.231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M312.78,232.126l5.276-0.068c-3.444-13.769-11.393-26.061-22.978-35.008   c-1.119-0.862-2.725-0.66-3.591,0.46c-0.864,1.12-0.657,2.727,0.461,3.59C302.274,209.075,309.459,219.939,312.78,232.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M308.025,226.323c-2.867-6.97-7.081-13.387-12.648-18.839c-1.01-0.99-2.628-0.972-3.62,0.04   c-0.99,1.01-0.972,2.63,0.037,3.62c5.584,5.469,9.693,11.994,12.274,19.101C305.145,228.938,306.442,227.623,308.025,226.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M319.705,253.685l-5.335,1.603l-2.683,0.806l-1.863,0.56l-8.059,2.422   c-2.253,0.676-4.127,2.252-5.179,4.356l-3.406,6.811c-1.742,2.866-3.764,5.523-6.076,7.883l5.88,1.077   c2.908-3.414,5.35-7.261,7.255-11.447l3.34-1.227c-1.916,4.795-4.538,9.234-7.728,13.199l5.649,1.034   c3.614-4.962,6.433-10.53,8.293-16.516l2.975-1.093c-1.8,6.561-4.702,12.67-8.497,18.117l5.53,1.012   c4.15-6.438,7.171-13.665,8.8-21.4c1.018-0.637,1.801-1.605,2.188-2.766l1.763-5.288L319.705,253.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M282.677,281.986l-0.132,0.117c-7.448,5.748-16.696,9.122-26.545,9.122s-19.097-3.375-26.545-9.122   l-0.132-0.117c-0.966-1.063-2.42-1.539-3.828-1.255l-25.809,5.374l5.727,5.02c1.532,1.342,3.5,1.969,5.457,1.854   c4.609,4.59,9.902,8.491,15.723,11.522l-1.677,3.095c9.247,5.029,19.838,7.888,31.084,7.888c11.246,0,21.837-2.859,31.084-7.888   l-1.677-3.095c5.82-3.031,11.114-6.932,15.723-11.522c1.957,0.115,3.926-0.512,5.457-1.854l5.727-5.02l-25.809-5.374   C285.097,280.447,283.643,280.923,282.677,281.986z M229.04,299.983c-4.64-2.414-8.888-5.463-12.71-8.969l2.485-1.185   c3.472,3.072,7.29,5.762,11.438,7.915L229.04,299.983z M295.67,291.014c-3.822,3.506-8.07,6.555-12.71,8.969l-1.213-2.239   c4.149-2.153,7.966-4.843,11.438-7.915L295.67,291.014z M256,298.904c-12.192,0-23.364-4.325-32.159-11.473l2.555-1.218   c8.305,6.397,18.625,10.131,29.604,10.131c10.978,0,21.299-3.734,29.604-10.131l2.555,1.218   C279.364,294.579,268.192,298.904,256,298.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M227.912,278.358c1.099,0.93,2.239,1.809,3.427,2.628h49.322c1.188-0.819,2.329-1.699,3.427-2.628   l-2.491-2.491h-51.195L227.912,278.358z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAf);
export default __webpack_public_path__ + "static/media/af.a24dbae3202d6c428648528186aa8e1b.svg";
export { ForwardRef as ReactComponent };